<template>
  <div class="row task-container">
    <div class="col-md-12" v-if="mainLoader">
      <div class="loader"></div>
    </div>
    <div v-else class="col-md-12">
      <div class="d-flex justify-content-between align-items-center" >
        <div class="d-flex align-items-center">
          <div class="pr-5"><label> Show </label></div>
            <select class="custom-select custom-select-sm form-control form-control-sm datatable-dropdown" id="grouped"  aria-describedby="grouped" required v-model="pageSize">
              <option value="10" >10</option>
              <option value="25" >25</option>
              <option value="50" >50</option>
              <option :value="tasks.length" >All</option>
            </select>
          <div class="pl-5"><label>entries</label></div>
        </div>
        <div class="d-flex align-items-center">
          <input v-model="searchQuery" type="text" class="form-control mr-5" style="height: 30px;" placeholder="Search..." />
          <button class="btn btn-primary"   data-toggle="modal"  data-target="#bulkRemoveCpanelDomain" @click="fixModal('bulkRemoveCpanelDomain')" >Bulk Resolve & Remove</button>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <table class="table table-striped task-table table-responsive " :id="tableId" v-if="tasks">
        <thead>
        <tr>
          <th class="text-center">
              <input type="checkbox" class="mt-5" aria-label="Checkbox for following text input"  v-model="checkAll" @click="checkUnCheckTasks" >
          </th>
          <th>Task Type</th>
          <th>Domain</th>
          <th>Is Primary</th>
          <th>WPO Email</th>
          <th>C Panel User Name</th>
          <th class="text-center">Created At</th>
          <th class="text-center">Action <i class="fa fa-bolt"></i></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(task,index) in paginatedTasks" :key="'queueTask_' + index">
          <td width="3%" class="text-center">
            <div v-if="!task.resolvedFromCpanel"><input type="checkbox" class="mt-5" aria-label="Checkbox for following text input"   v-model="task.isChecked"  ></div>
            <div v-else></div>
          </td>
          <td width="10%">
            {{formattedText(task.text)}}
          </td>
          <td width="10%" style=" word-break: break-all;"><span :id='task.id' data-toggle="tooltip" data-placement="top" data-html="true" :key="task.domain+'break'" :title="task.domain"  >{{task.domain}}</span></td>
          <td width="5%" class="text-center">
            <span class="badge badge-info">{{task.isPrimary}}</span>
          </td>
          <td width="10%">{{task.email}}</td>
          <td width="7%">{{task.cPanelUserName}}</td>
          <td width="5%" class="text-center">
            <span class="badge badge-info">{{task.createdAt | formatDate}}</span>
          </td>
          <td  width= "10%" class="text-center">
            <div class="d-flex align-items-center">
            <button v-if='!task.resolvedBy' :disabled="loading" class="btn btn-primary btn-sm mr-2 " @click="resolveTask(task, index)">
              <div class="loader mini_loader" v-if="getTaskLoader && loading && resolvingIndex === index "></div>
              <span v-else><i class="fa fa-refresh"></i> Resolve</span>
            </button>
              <div v-else  class="mr-2 cursor-pointer" >
                <div class="loader mini_loader" v-if="getTaskLoader && loading && resolvingIndex === index "></div>
                <span  v-else class="badge badge-pill badge-success">
                      {{ task.resolvedBy }}
                      <a href="javascript:void(0)" @click="removeResolvedBy(task, index)" v-if="!task.resolvedFromCpanel" class="fa fa-times text-white"></a>
                    </span>
              </div>
              <button v-if="task.isPrimary" :disabled="loading && task.isPrimary"  style = 'opacity: .5;' class="btn btn-primary btn-sm mr-2 cursor-pointer"  title="This domain can not be removed since it is the primary domain. " data-toggle="tooltip" data-placement="top" :key="task.domain+'task'" data-html="true" >
              <div class="loader mini_loader" v-if="getTaskLoader && loading && resolvingIndex === index "></div>
              <span v-else><i class="fa fa-refresh"></i> Resolve & Remove</span>
              </button>
              <template v-else  >
              <button v-if="!task.resolvedFromCpanel"  :disabled="loading || task.isPrimary"  class="btn btn-primary btn-sm mr-2" @click="resolveRemoveTask(task, index)">
                <div class="loader mini_loader" v-if="getTaskLoader && loading && resolvingRemovingIndex === index "></div>
                <span v-else><i class="fa fa-refresh"></i> Resolve & Remove</span>
              </button>
                <div v-else  class="mr-2 cursor-pointer" >
                  <div class="loader mini_loader" v-if="getTaskLoader && loading && resolvingIndex === index "></div>
                  <span  v-else class="badge badge-pill badge-info">
                       Removed From CPanel
                    </span>
                </div>
              </template>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="row mt-10" v-if="tasks.length > 0 ">
        <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                       <b>Page {{pageNumber +1 }} of {{pageCount}}</b>
                    </span>
          <section class="dataTables_paginate paging_full_numbers">
            <paginate
                id="tableId"
                ref="paginate"
                :pageCount="pageCount"
                :clickHandler="goToPage"
                :prevText="'Prev'"
                :nextText="'Next'"
                page-class="page-item"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
                page-link-class="page-link"
                containerClass="pagination">
            </paginate>
          </section>
        </div>
      </div>
    </div>

      <div class="bulkRemoveCpanelDomain modal fade" id="bulkRemoveCpanelDomain" tabindex="-1" role="dialog" aria-labelledby="bulkRemoveCpanelDomain" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <form @submit.prevent="bulkRemoveDelete">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Bulk Remove and Resolve Domains</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row mt-5" v-if="selectedBulkDomains.length">
                  <perfect-scrollbar class="scroll-area col-md-12">
                    <table class="table single-outage-table">
                      <thead>
                      <tr>
                        <th><b>Domain Name</b></th>
                        <th class="text-center">IsPrimary</th>
                        <th class="text-center">Resolve</th>
                        <th class="text-center">Resolve & Remove <i class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" title="Primary Domains can not be removed."></i> </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, index) in selectedBulkDomains" :key="index">
                        <td>{{ row.domain }}</td>
                        <td class="text-center"> <span class="badge badge-info">{{row.isPrimary}}</span></td>
                        <td>
                          <div class="custom-control custom-checkbox d-flex justify-content-center mb-15">
                            <input type="radio" class="custom-control-input " :name="`${index}forResolve`"  value="resolve" v-model="row.action" :id="`${index}resolve`" :checked="row.action === 'resolve'"/>
                            <label class="custom-control-label" :for="`${index}resolve`"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center mb-15">
                            <input type="radio" class="custom-control-input" :name="`${index}forResolve`" :disabled="row.isPrimary" v-model="row.action"   value="removeResolve" :id="`${index}resolveRemove`" :checked="row.action === 'removeResolve'"/>
                            <label class="custom-control-label" :for="`${index}resolveRemove`"></label>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </perfect-scrollbar>
                </div>
                <div class="row mt-5" v-else>
                  <p class="text-primary">No Domains selected</p>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary" :disabled="bulkDomainProcessing || !selectedBulkDomains.length">
                  <div class="loader small_loader" v-if="bulkDomainProcessing"></div>
                  <span v-else>Submit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
</template>

<script>
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import Paginate from 'vuejs-paginate'
import copyButtonMixin from '../../../mixins/copyButtonMixin';
import statisticsMixin from '../../../mixins/statisticsMixin';
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import moment from "moment/moment";
export default {
  name: "missingCpanelDomainTaskList",
  mixins: [copyButtonMixin, statisticsMixin],
  components: {Paginate, PerfectScrollbar},
  props: {
    tasks: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true
    },
    tableId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mainLoader: false,
      selectedTask: {
      },
      selectedIndex: -1,
      resolvingIndex: -1,
      resolveAllLoader: false,
      task : null,
      checkAll: false,
      finalSelectedBulkDomains: [],
      resolvingRemovingIndex: -1,
      taskList: [],
      pageNumber: 0,
      pageSize: 10,
      pageNum: 0,
      searchQuery: '',
      bulkDomainProcessing: false,
      selectedBulkDomains : [],
      selectedDomainsForResolve: [],
      selectedDomainsForResolveNRemove: [],
      loading: false,
    }
  },
  watch: {
    pageSize() {
      this.pageNumber = 0;
      this.$refs.paginate.innerValue = 1;
    },
  },
  computed: {
    getTaskLoader() {
      return this.$store.getters['tasks/getTaskLoader'];
    },
    user () {
      return this.$store.getters.user;
    },
    groupTasks(){
      let allRemarks = this.tasks;
      if(this.searchQuery.length) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.pageNumber = 0;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$refs.paginate.innerValue = 1;
        allRemarks = allRemarks.filter(el => {
          return el.domain && el.domain.toLowerCase().includes(this.searchQuery);
        })
        // eslint-disable-next-line vue/no-async-in-computed-properties
      }
      return allRemarks;
    },
    pageCount(){
      let l = this.groupTasks.length, s = this.pageSize;
      return Math.ceil(l/s);
    },
    paginatedTasks(){
      const start = this.pageNumber * this.pageSize, end = Number(start) + Number(this.pageSize);
      console.log(start,end, 'start end values')
      // eslint-disable-next-line vue/no-async-in-computed-properties
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
      return  this.groupTasks.slice(start, end)
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    },
    // eslint-disable-next-line vue/no-dupe-keys
  },
  methods: {
    fixModal() {
      this.selectedBulkDomains =  this.tasks.filter((task)=> task.isChecked);
      this.selectedBulkDomains = this.selectedBulkDomains.map((value) => ({ ...value, action: value.isPrimary === true ? 'resolve' : 'removeResolve'}));
      this.selectedDomainsForResolve = []
      this.selectedDomainsForResolveNRemove = []

      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      $(`#bulkRemoveCpanelDomain`).modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
     formattedText(text){
       if(text){
         return  text.slice(7)
       }
       return null
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum-1;
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    async checkUnCheckTasks(){
     for(const t of this.tasks){
       t.isChecked = !this.checkAll
     }
    },
    async bulkRemoveDelete(){
      this.searchQuery= ''
      $(`#bulkRemoveCpanelDomain`).modal('hide');
      const {value} = await swal({
        title: "Are you sure?",
        text: 'Please confirm that you want to perform bulk action on the selected domains',
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
      if(value){
        console.log('this action ', this.selectedBulkDomains)
        try {
        await this.$http.post('/domain/deleteBulkCpanelDomain', {
          grant_type: 'token',
          tasks: this.selectedBulkDomains,
        })
        }
       catch(e){
        console.log(e.toString(), 'Failed to bulk resolve and delete domains')
      }
      }
    },
    async resolveRemoveTask(task, index){
      this.searchQuery= ''
      const {value} = await swal({
        title: "Are you sure?",
        text: 'Please confirm that you want to resolve and remove the selected domain',
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
      if(value){
        this.task= task
        this.resolvingRemovingIndex = index;
        this.loading = true;
        await this.$store.dispatch('tasks/changeTaskLoader', true);
        try{
          await this.$http.post('/domain/deleteCpanelDomain', {
            grant_type: 'token',
            domain: task.domain,
          })
          await db.collection('bigScootsTasks').doc(task.docId).update({
            resolvedFromCpanel: true,
            resolvedAt: new Date().toISOString(),
            resolvedBy: `${this.user.firstName} ${this.user.lastName}`
          })
        }
        catch(e){
          console.log('Could not update task', e.toString())
        }
        try{
          await this.incrementCountBasedOnType(this.user, 'support')
        }catch (e) {
          console.log('line 392', e.toString())
        }
        this.loading = false;
        this.resolvingRemovingIndex = -1;
      }
    },
    async resolveTask (task, index) {
      this.searchQuery= ''
      const {value} = await swal({
        title: "Are you sure?",
        text: 'Please confirm that you want to resolve selected domain',
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
      if(value){
        this.task= task
        console.log('task was resolved', task)
        this.resolvingIndex = index;
        this.loading = true;
        await this.$store.dispatch('tasks/changeTaskLoader', true);
        try{
          await db.collection('bigScootsTasks').doc(task.docId).update({
            resolvedAt: new Date().toISOString(),
            resolvedBy: `${this.user.firstName} ${this.user.lastName}`
          })

        }
        catch(e){
          console.log('Could not update task', e.toString())
        }
        try{
          await this.incrementCountBasedOnType(this.user, 'support')
        }catch (e) {
          console.log('line 392', e.toString())
        }
        this.loading = false;
        this.resolvingIndex = -1;
        await this.$store.dispatch('tasks/changeTaskLoader', false);
      }
    },
    async removeResolvedBy(task, index){
      this.task= task
      this.searchQuery= ''
      console.log('task was resolved', task)
      this.resolvingIndex = index;
      this.loading = true;
      await this.$store.dispatch('tasks/changeTaskLoader', true);
      try{
        await db.collection('bigScootsTasks').doc(task.docId).update({
          resolvedAt: new Date().toISOString(),
          resolvedBy: ``
        })

      }
      catch(e){
        console.log('Could not update task', e.toString())
      }
      this.loading = false;
      this.resolvingIndex = -1;
      await this.$store.dispatch('tasks/changeTaskLoader', false);
    },
  },
  beforeDestroyed(){
    console.log('Before destroying, release all listeners...');
  }
}
</script>

<style scoped lang="scss">
.dropdown-toggle:after {
  display: none;
}
.task-container{
  padding: 1.5em;
}
.cf-status-icons {
  i {
    font-size: 25px;

    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
  }
}
.click-to-copy{
  margin: 0 !important;
  padding: 7px !important;
}
.custom-checkbox{
  display: flex;
  align-items: center;
  padding-bottom: 5px;
}
.dataTables_wrapper .dataTables_filter,
.dataTables_wrapper .dataTables_length {
  text-align: left;
}
</style>
